import axios from 'axios'
import { EmailProviderEnum } from '../models/EmailConfig'
import { IRecipientQueryModel, MessageTypeEnum } from '../models/Recipients'

const BASE_URL = 'inbox2/'
const LABELS_URL = BASE_URL + 'labels/'
const CONFIG_URL = BASE_URL + 'configurations/'
const recipientsUrl = (clientId: string) =>
  `${BASE_URL}clients/${clientId}/recipients/`
const clientUrl = (clientId: string) => `client/clients/${clientId}/`

/**
 * Configuration
 */
export const getConfiguration = (clientId: string) =>
  axios.get(`${CONFIG_URL}${clientId}`)

export const initConfiguration = (
  clientId: string,
  emailProvider: EmailProviderEnum,
  returnUrl: string,
  email: string
) => axios.post(`${CONFIG_URL}${clientId}`, { emailProvider, returnUrl, email })

export const confirmConfiguration = (
  clientId: string,
  emailProvider: EmailProviderEnum,
  email: string,
  syncFromDate: Date
) =>
  axios.post(`${CONFIG_URL}${clientId}/confirmation`, {
    emailProvider,
    email,
    syncFromDate,
  })

export const deleteConfiguration = (clientId: string) =>
  axios.delete(`${CONFIG_URL}${clientId}`)

export const syncInbox = (
  clientId: string,
  syncFromDate: Date,
  emailProvider: EmailProviderEnum
) =>
  axios.post(`${CONFIG_URL}${clientId}/sync`, { syncFromDate, emailProvider })

export const confirmGmailSmtpConfiguration = (
  clientId: string,
  email: string,
  appPassword: string,
  syncFromDate: Date
) =>
  axios.post(`${CONFIG_URL}/gmail/${clientId}`, {
    email,
    appPassword,
    syncFromDate,
  })
export const confirmOfficeSmtpConfiguration = (
  clientId: string,
  email: string,
  password: string,
  syncFromDate: Date
) =>
  axios.post(`${CONFIG_URL}/office365/${clientId}`, {
    email,
    password,
    syncFromDate,
  })

/**
 * Labels
 */
export const getLabels = (clientId: string) =>
  axios.get(`${BASE_URL}clients/${clientId}/labels`)

export const getLabel = (id: string) => axios.get(`${LABELS_URL}${id}`)

export const createLabel = (clientId: string, path: string) =>
  axios.post(`${LABELS_URL}`, { clientId, path })

export const deleteLabel = (id: string) => axios.delete(`${LABELS_URL}${id}`)

export const updateLabel = (id: string, path: string) =>
  axios.put(`${LABELS_URL}${id}`, { path })

/**
 * Signature
 */
export const getSignature = (clientId: string) =>
  axios.get(`${CONFIG_URL}${clientId}/signature`)

export const updateSignature = (clientId: string, value: string) =>
  axios.put(`${CONFIG_URL}${clientId}/signature`, { additionalLines: value })

/**
 * Recipients
 */
export const getFrequentRecipients = (
  clientId: string,
  type: MessageTypeEnum
) =>
  axios.get(`${BASE_URL}clients/${clientId}/frequentrecipients/?type=${type}`)

export const getRecipients = (clientId: string, body: IRecipientQueryModel) =>
  axios.post(`${recipientsUrl(clientId)}`, body)

export const getRecipientsMeterContacts = (
  clientId: string,
  filter: IRecipientQueryModel
) =>
  axios.post(`${clientUrl(clientId)}metercontacts/query`, filter, {
    headers: {
      'x-api-version': '',
    },
  })

export const getRecipientsObjectContacts = (
  clientId: string,
  filter: IRecipientQueryModel
) =>
  axios.post(`${clientUrl(clientId)}objectcontacts/query`, filter, {
    headers: {
      'x-api-version': '',
    },
  })

export const getRecipeintsObjectTypes = (clientId: string) =>
  axios.get(`${clientUrl(clientId)}objecttypes?filterOption=1`)

export const getRecipientsMeterTypes = (clientId: string) =>
  axios.get(`${clientUrl(clientId)}metertypes?filterOption=1`)

/**
 * Cases
 */

export const getAvailableCases = (clientId: string) =>
  axios.get(`${BASE_URL}client/${clientId}/availablecases`)

export const connectMessagesToCase = (caseId: string, messageIds: string[]) =>
  axios.put(`${BASE_URL}cases/${caseId}/messages`, { messageIds })
